import { render } from "./BlogComp.vue?vue&type=template&id=34c1d1c6"
import script from "./BlogComp.vue?vue&type=script&lang=js"
export * from "./BlogComp.vue?vue&type=script&lang=js"

import "./BlogComp.vue?vue&type=style&index=0&id=34c1d1c6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__